import * as PIXI from 'pixi.js'
import * as dat from 'dat.gui'
import ScenesManager from './scenes-manager.js'
import shortid from 'shortid'
import track from './track.js'

class Game {
  constructor () {
    PIXI.utils.skipHello()

    this.id = this.getLocalID() || this.generateLocalID()

    track('user', { id: this.id })

    if (window.Rollbar) {
      window.Rollbar.configure({
        payload: {
          person: {
            id: this.id,
          }
        }
      })
    }

    this.app = new PIXI.Application({
      // The width & height of the renderers view.
      width: 335,
      height: 600,

      // the canvas to use as a view.
      view: document.getElementById('canvas'),

      // Sets antialias (only applicable in Chrome at the moment).
      antialias: true,

      // The resolution / device pixel ratio of the renderer, retina would be 2.
      resolution: 2,

      // If the render view is transparent.
      transparent: true
    })

    this.debugMode = false

    this.app.renderer.realWidth = ~~(this.app.renderer.width / this.app.renderer.resolution)
    this.app.renderer.realHeight = ~~(this.app.renderer.height / this.app.renderer.resolution)

    this.scenesManager = new ScenesManager(this)
    this.audioEnabled = true

    this.isPlayed = false

    if (this.debugMode) {
      this.gui = new dat.GUI()
    }
  }

  start () {
    this.scenesManager.init()
  }

  getLocalID () {
    if (window.localStorage) {
      return window.localStorage.getItem('gameID')
    }

    return null
  }

  generateLocalID () {
    const id = shortid.generate()

    if (window.localStorage) {
      window.localStorage.setItem('gameID', id)
    }

    return id
  }
}

export default Game
